import * as Yup from 'yup';

export const getTransferSchema = (cashboxes = []) =>
  Yup.object().shape({
    from: Yup.object()
      .nullable()
      .required("Обов'язкове поле")
      .test('different-accounts', 'Не можна переводити в той самий сейф', function (value) {
        const to = this.parent?.to;
        return !to || value?.value !== to?.value;
      }),
    to: Yup.object()
      .nullable()
      .required("Обов'язкове поле")
      .test('different-accounts', 'Не можна переводити в той самий сейф', function (value) {
        const from = this.parent?.from;
        return !from || value?.value !== from?.value;
      }),
    amount: Yup.number()
      .typeError('Сума повинна бути числом')
      .required("Обов'язкове поле")
      .integer('Повинно бути ціле число')
      .positive('Сума повинна бути більше нуля')
      .test('enough-balance', 'Недостатньо коштів в сейфі', function (value) {
        const fromId = this.parent?.from?.value;
        const fromCashbox = cashboxes.find((c) => c.id === parseInt(fromId));
        return !fromCashbox || value <= fromCashbox.balance;
      }),
  });
